module.exports = __webpack_public_path__ + "img/vuma-business-banner.3ba95197.jpg";